<template>
    <div class="loginWrapper">
        <div class="loginBox">
            <div class="title">壹家壹品</div>
            <div class="item">
                <label>
                    <i class="el-icon-user"></i>
                    <input type="text"
                           placeholder="请输入用户名"
                           v-model="form.email">
                </label>
            </div>
            <div class="item">
                <label>
                    <i class="el-icon-lock"></i>
                    <input type="password"
                           placeholder="请输入密码"
                           v-model="password">
                </label>
            </div>
            <div class="item verifyCode">
                <label>
                    <input type="text"
                           id="verifyCode"
                           placeholder="请输入验证码"
                           v-model="form.verifycode" @keyup.enter="submit">
                </label>
                <img :src="verifyCodeImg" alt="验证码图片" @click="getVerifyCode">
            </div>
<!--            <p class="wrongMsg">密码错误</p>-->
            <button class="loginButton" @click="submit">登录</button>
        </div>
    </div>
</template>

<script>
    import hash from '../../../static/js/hashes.min'
    export default {
        name: "Login",
        data(){
            return {
                form:{
                    email:'',
                    password:'',
                    verifycode:'',
                    rememberme: 0,
                },
                password:'',
                verifyCodeImg:'',
                checkStatus:false
            }
        },
        methods:{
            getVerifyCode(){
                this.verifyCodeImg = this.zzlApi.domain + this.zzlApi.verifyCodeImg + Math.random()
            },
            checkOutAll(){
                if (this.form.email.trim() === '') {
                    this.$message({
                        showClose: true,
                        message: '用户名不能为空',
                        type: 'error'
                    })
                }else if (this.password.trim() === '') {
                    this.$message({
                        showClose: true,
                        message: '密码不能为空',
                        type: 'error'
                    })
                }else if (this.form.verifycode.trim() === '') {
                    this.$message({
                        showClose: true,
                        message: '验证码不能为空',
                        type: 'error'
                    })
                }
                else{
                    this.checkStatus = true
                }

            },
            async submit(){
                this.checkOutAll()
                if(this.checkStatus){
                    this.form.password = new hash.MD5().hex(this.password + '_zzlfe25ec32c2d65')
					this.form.Name = this.form.email
					this.form.Pwd = this.form.password
					this.form.Vcode = this.form.verifycode
                    let params = this.form
                    const res = await this.zzlHttp.post(this.zzlApi.login,params)
                    if (res.status === 'Success' && res.code === 0) {
                        window.sessionStorage.setItem('isLogin', 'true');
                        window.sessionStorage.setItem('loginData', JSON.stringify(res.data));
                        this.$message({
                            message: '用户 ' + this.form.email + ' 登陆成功！',
                            type: 'success'
                        })
                        setTimeout(() => {
                            this.$router.push({name: 'Frame'}).catch(data => {  })
                        }, 300);

                    }else if (res.code === 500) {
                        this.$message.error('账号被锁定')
                        this.getVerifyCode()
                        this.form.verifycode = ''
                    } else if (res.code === 501) {
                        this.$message.error('验证码错误')
                        this.getVerifyCode()
                        document.getElementById('verifyCode').focus()
                        this.form.verifycode = ''
                    } else if (res.code === 502) {
                        this.$message.error('账号或密码错误')
                        this.getVerifyCode()
                        this.form.verifycode = ''
                    }
                }


            },
        },
        mounted() {
            this.getVerifyCode()
        }
    }
</script>

<style lang="scss" scoped>

    .loginWrapper{
        display: flex;
        justify-content: center;
        width: 100%;
        height: 100vh;
        background-image: url("../../../static/images/loginBg.jpg");
        background-size: cover;
        .loginBox{
            margin-top: 160px;
            width: 400px;
            height: 400px;
            background: #ddd;
            border-radius: 16px;
            background: rgba(248, 248, 248, .7);
            .title{
                text-align: center;
                font-size: 24px;
                color: #2E80DE;
                font-weight: bold;
                padding: 30px 0;
            }
            .item{
                margin: 0 40px 16px;
                position: relative;
                i{
                    position: absolute;
                    font-size: 24px;
                    top: 10px;
                    left: 8px;
                    color: #2E80DE;
                }
                input{
                    height: 44px;
                    width: 100%;
                    border-radius: 6px;
                    border: none;
                    font-size: 16px;
                    padding-left: 40px;
                }

                img{
                    width: 40%;
                    height: 44px;
                    margin-left: 6px;
                    border-radius: 6px;
                }
            }
            .verifyCode{
                display: flex;
                input{
                    padding-left: 20px;
                }
            }
            .wrongMsg{
                color: red;
                font-size: 16px;
                padding-left: 40px;
            }
            .loginButton{
                width: calc(100% - 80px);
                height: 44px;
                margin: 20px 40px 0;
                background: #2E80DE;
                border-radius: 6px;
                border: none;
                color: #FFFFFF;
                font-size: 18px;
            }
        }
    }
</style>
